// Mood Board Color
export const BG_PRIMARY = '#F2EADF';
export const BG_SECONDARY = '#E6DBC9';
export const BG_ALTERNATIVE = '#FFFFFF';
export const BG_OPACITY = 'rgba(192, 176, 151, 0.65)';

export const ASSETS_PRIMARY = '#EBDCC7';
// Text Color
export const TEXT_PRIMARY = '#7C7569';
export const TEXT_SECONDARY = '#7C7569';
export const TEXT_ALTERNATIVE = '#323030';

// Music & Navigation Color
export const NAVIGATION_COLOR = '#ffffffff'; // Warna BG
export const ICON_NAVIGATION_COLOR = '#7C7569'; // Warna Iconnya

